import React from 'react'
import { Link as RouterLink, LinkProps as RouterLinkProps, To } from 'react-router-dom'
import { UrlPattern } from '@/utils/formValidation'
import { LinkIcon } from 'lucide-react'

export interface LinkProps
  extends Omit<RouterLinkProps, 'to'>,
    React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to?: To | string
  showIcon?: boolean
}

export const Link: React.FC<LinkProps> = ({
  to,
  showIcon = false,
  className = '',
  children,
  ...rest
}) => {
  const baseStyles = showIcon
    ? 'whitespace-nowrap px-1 inline-flex items-center gap-1 text-primary hover:text-primary/80'
    : ''
  const icon = showIcon ? <LinkIcon className='size-4' /> : null

  if (!to) {
    return (
      <span className={className} {...rest}>
        {icon}
        {children}
      </span>
    )
  }

  if (typeof to === 'string' && UrlPattern.test(to)) {
    const target = rest.target ?? '_blank'
    const rel = target === '_blank' ? (rest.rel ?? 'noopener noreferrer') : rest.rel

    return (
      <a href={to} className={`${baseStyles} ${className}`} target={target} rel={rel} {...rest}>
        {icon}
        {children}
      </a>
    )
  }

  return (
    <RouterLink to={to} className={`${baseStyles} ${className}`} {...rest}>
      {icon}
      {children}
    </RouterLink>
  )
}
